module.exports = __webpack_public_path__ + "img/noproctorgroups.d6eaa2cc.svg";